import { $emit } from '../includes/event-bus'
import { useStore } from '../stores/index'
import { useUserStore } from '../stores/user'
import userAxios from '../includes/axios'
import { redirectToEntrance } from '../includes/shared'

async function loadUserData(){
	const userStore = useUserStore()

	// Returning promise
	try {
		const { data } = await userAxios.get('/api/user-side/getUserData', {
			validateStatus: null // Ignore interceptor in this case, as it will not trigger promise chained promise below
		})

		// If user is not initialized, act as there are no user
		if (data.user_initialized) {
			storeUserData(data)
		} else {
			userStore.loggedIn = false
		}
	} finally {
		userStore.userLoaded = true
	}
}

function storeUserData(data: any): void
{
	const store = useStore()
	const userStore = useUserStore()

	store.referralId = data.referral_id
	store.applyReferralCodeEnabled = data.applyReferralCodeEnabled
	store.applyPromoCodeEnabled = data.applyPromoCodeEnabled

	userStore.loggedIn = true
	userStore.userPhone = data.primary_phone ? data.primary_phone.replace(/^\+/g, "") : ""
	userStore.isInMonthlyTop = !!data.is_in_monthly_top
	userStore.monthlyTopUrl = data.monthly_top_url
	userStore.userEmail = data.primary_email
	userStore.userHash = data.user_external_id_hash
	userStore.birthday = data.birthday
	userStore.connectionStatus = data.external_accounts || {}
	userStore.connectionStatusDetails = data.external_accounts_details || {}
	userStore.activeSessions = data.active_sessions || null
	
	userStore.setUserFirstName(data.name)
	userStore.setUserLastName(data.surname)
	userStore.setUserPicture(data.picture_url)
	
	userStore.notificationSettings = {
		monthly: data.monthly_notification,
		challengeCompletion: data.challenge_completion_notification,
		newChallenges: data.new_challenges_notification,
		news: data.user_news_notification,
		newFriendConnected: data.new_friend_connected_notification,
	}
}

export async function loadExternalAccountsConnectionStatus()
{
	const userStore = useUserStore()

	try{
		const { data } = await userAxios.get('/api/user-side/getUserExternalAccountDetails')
		
		// Update connection status in the store and connections array
		for(const accountType of data){
			userStore.connectionStatus[accountType.external_account_type] = accountType.external_account_connected
			if(accountType.external_account_connected == 'connected'){
				userStore.connectionStatusDetails[accountType.external_account_type] = accountType 
			}else{
				delete userStore.connectionStatusDetails[accountType.external_account_type]
			}
		}
	} catch (e) {
		if(e.response.status == 399){
			// Catch 399 error which means that user was probably deleted while logged in
			redirectToEntrance()
		}

		throw e
	}
}

async function updateUserPoints(value = null): Promise<void>
{
	const userStore = useUserStore()

	const { data } = await userAxios.get('/api/user-side/getUserPoints')
	
	userStore.userPoints = value ? value : (+data?.points_balance || 0)
	userStore.userTotalPoints = value ? value : (+data?.points_total_earned || 0)
}

export {
	loadUserData,
	updateUserPoints
}